import { DaccaActionTypes } from './types';
import { DaccaCalculationResponse } from './model';
import { action } from 'typesafe-actions';

export const openDacca = () => action(DaccaActionTypes.OPEN_DACCA);

export const importLinesFromDacca = (reportType: string, caseCode: string, reference: number) =>
  action(DaccaActionTypes.IMPORT_LINES_FROM_DACCA, { reportType, caseCode, reference });

export const importLinesFromDaccaSuccess = () =>
  action(DaccaActionTypes.IMPORT_LINES_FROM_DACCA_SUCCESS);

export const importLinesFromDaccaError = (message: string) =>
  action(DaccaActionTypes.IMPORT_LINES_FROM_DACCA_FAIL, { message });

export const fetchDaccaCalculations = (caseCode: string) =>
  action(DaccaActionTypes.FETCH_DACCA_CALCULATIONS, { caseCode });

export const fetchDaccaCalculationsSuccess = (daccaCalculations: DaccaCalculationResponse[]) =>
  action(DaccaActionTypes.FETCH_DACCA_CALCULATIONS_SUCCESS, daccaCalculations);

export const fetchDaccaCalculationsError = (message: string) =>
  action(DaccaActionTypes.FETCH_DACCA_CALCULATIONS_FAIL, { message });

export const fetchDaccaToken = () =>
  action(DaccaActionTypes.FETCH_DACCA_TOKEN);

export const fetchDaccaTokenSuccess = (daccaToken: string) =>
  action(DaccaActionTypes.FETCH_DACCA_TOKEN_SUCCESS, { daccaToken });

export const fetchDaccaTokenError = (message: string) =>
  action(DaccaActionTypes.FETCH_DACCA_TOKEN_FAIL, { message });
